export default __webpack_public_path__ + "static/media/presentationBackground.42f51b23.png";